var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Client } from "./client";
;
// TODO: stephen look at moving this into the models
var ManagedClient = /** @class */ (function (_super) {
    __extends(ManagedClient, _super);
    function ManagedClient() {
        var _this = _super.call(this) || this;
        _this.assignments = [];
        return _this;
    }
    Object.defineProperty(ManagedClient.prototype, "user", {
        get: function () {
            return this.assignedUser;
        },
        set: function (v) {
            this.assignedUser = v;
        },
        enumerable: true,
        configurable: true
    });
    ManagedClient.prototype.getAssessmentGroups = function () {
        var groups = [];
        this.assignments.forEach(function (a) {
            if (a.Type == "AssessmentGroup") {
                groups.push(a);
            }
        });
        return groups;
    };
    /**
     * Looks for the passed in assignment and removes it if it is found
     * in the current client.  If it is not found it's treated as a no-op.
     */
    ManagedClient.prototype.removeAssignment = function (assignment) {
        var indexOf = this.assignments.indexOf(assignment);
        if (indexOf >= 0) {
            this.assignments.splice(indexOf, 1);
        }
    };
    ManagedClient.prototype.getAssignmentsCompleted = function () {
        return this.assignments.filter(function (a) { return a.IsComplete; }).length;
    };
    ManagedClient.prototype.hasNoAssignments = function () {
        return this.assignments.length == 0;
    };
    ManagedClient.prototype.hasFinishedAllAssignments = function () {
        if (this.assignments.length) {
            return this.assignments.every(function (a) { return a.IsComplete; });
        }
        return false;
    };
    ManagedClient.prototype.getNextAssignmentItemToComplete = function () {
        // find the first assignment that is not complete.
        var assignment = this.assignments.find(function (a) { return !a.IsComplete; });
        if (!assignment) {
            return null;
        }
        var item = assignment.getNextAssignmentItemToComplete();
        if (!item) {
            console.error("Assignment marked as incomplete but items are complete. Assignment:", assignment);
        }
        return item;
    };
    ManagedClient.prototype.getAssignment = function (id) {
        if (!this.assignments) {
            return null;
        }
        return this.assignments.find(function (a) { return a.Id == id; });
    };
    ManagedClient.prototype.findAssignmentItem = function (id) {
        var assignment = null;
        this.assignments.some(function (a) {
            var item = a.Items.find(function (i) { return i.Id == id; });
            if (item) {
                assignment = item;
                return true;
            }
            return false;
        });
        return assignment;
    };
    ManagedClient.prototype.hasStartedAssignments = function () {
        return this.assignments && this.assignments.length && this.assignments[0].IsComplete;
    };
    ManagedClient.prototype.getDisplayString = function () {
        var name = [];
        if (this.firstName || this.lastName) {
            if (this.firstName) {
                name.push(" ");
                name.push(this.firstName);
            }
            if (this.lastName) {
                name.push(" ");
                name.push(this.lastName);
            }
        }
        else {
            name.push("<NAME MISSING>");
        }
        return name.join("");
    };
    ManagedClient.prototype.findAssignmentForAssignmentItem = function (item) {
        return this.assignments.find(function (a) { return a.hasItem(item); });
    };
    ManagedClient.prototype.findAssignmentItemForAssessmentUid = function (uid) {
        var assignment = this.assignments.find(function (a) {
            if (a.Type == "Assessment" && a.Items.length) {
                var assignedAssessment = a.Items[0];
                if (assignedAssessment.Uid == uid) {
                    return true;
                }
                return false;
            }
        });
        if (assignment) {
            return assignment.Items[0];
        }
        return null;
    };
    ManagedClient.prototype.findAssignmentItemForAssetId = function (assetId) {
        var assignment = this.assignments.find(function (a) {
            if (a.Type == "LibraryAsset") {
                var assignedAsset = a.Items[0];
                if (assignedAsset.AssetId == assetId) {
                    return true;
                }
                return false;
            }
        });
        if (assignment) {
            return assignment.Items[0];
        }
        return null;
    };
    ManagedClient.prototype.markAssignmentCompleted = function (item) {
        if (!(item && item.Id)) {
            throw new Error("Missing item or item id");
        }
        var assignment = this.findAssignmentForAssignmentItem(item);
        if (assignment) {
            assignment.markCompleted(item);
        }
        else {
            throw new Error("Failed to find assignment for item" + item.Id);
        }
    };
    return ManagedClient;
}(Client));
export { ManagedClient };



// WEBPACK FOOTER //
// ./src/app/shared/models/managed-client.ts.pre-build-optimizer.js